import { setCookie, getCookie, expireDateGenerator } from '../../utils/cookies';

const navigationOptions = {
  otherLocation: `${document.location.origin}/nba/`,
  usLocation: 'http://www.nba.com/gr/reflectIntl.html?gr=italyuw&page=www&&dur=1w',
  editionCookie: 'nba_sky_it_hp',
};
const indexButton = document.querySelector('.j-set-nba-cookie');
const editionButton = document.querySelector('.j-set-nba-edition');
const selectEdition = document.querySelectorAll('.j-nav-custom-edition [name="edition"]');
const editionBox = document.querySelector('.j-nav-custom-edition');
const selectedEdition = document.querySelectorAll('.j-nav-custom-edition__input');
const editionForm = document.querySelector('.j-nav-custom-edition__form');
const editionMessage = document.querySelector('.j-nav-custom-edition__message');

const editionSetMessage = () => {
  delete editionMessage.dataset.state;
  editionForm.dataset.state = 'is-hidden';
};

const setHpDefault = (elementChecked) => {
  if (elementChecked === 'us') {
    const cookieOption = {
      expires: expireDateGenerator({ days: 7 }),
      insecure: true,
    };

    // if set cookie clear session storage
    sessionStorage.clear();
    setCookie(navigationOptions.editionCookie, elementChecked, cookieOption);
  } else {
    // if set session storage clear cookie;
    sessionStorage.setItem(navigationOptions.editionCookie, 'it');
    document.cookie = `${navigationOptions.editionCookie}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }

  // show edition message
  editionSetMessage();

  setTimeout(() => {
    delete editionBox.dataset.state;
  }, 3000);
};

// check the cookie and set the radio button
const checkEditionRadio = () => {
  const editionCookie = getCookie(navigationOptions.editionCookie);
  const editionStorage = sessionStorage.getItem(navigationOptions.editionCookie);
  if (editionCookie !== undefined || editionStorage !== undefined) {
    selectedEdition.forEach((element) => {
      if (element.value === editionCookie || element.value === editionStorage) {
        element.checked = true;
      }
    });
  }
};

const initGlobalNba = () => {
  indexButton.addEventListener('click', () => {
    window.open(navigationOptions.usLocation, '_blank');
  });
  editionButton?.addEventListener('click', () => {
    // check if there are saved a cookie
    checkEditionRadio();

    if (editionForm.dataset.state === 'is-hidden') {
      editionMessage.dataset.state = 'is-hidden';
    }

    if (!editionBox.dataset.state) {
      delete editionForm.dataset.state;
      editionBox.dataset.state = 'is-visible';
    } else {
      delete editionBox.dataset.state;
    }
  });
  selectEdition.forEach((element) => {
    element.addEventListener('click', () => {
      selectedEdition.forEach((elementChecked) => {
        if (elementChecked.checked) {
          setHpDefault(elementChecked.value);
        }
      });
    });
  });
};

export { initGlobalNba };
